/**
 * Decodes HTML entities in a string
 * Handles entities like &#8220; (curly quotes), &amp;, &lt;, etc.
 * @param text - The text containing HTML entities
 * @returns The decoded text
 */
export const decodeHtmlEntities = (text: string): string => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
};

